// eslint-disable-next-line no-restricted-imports
import { UserFragment } from 'api/generated/graphql';
import { UserEntity } from 'api/types/entity';

export const parseEntity = (user: UserFragment): UserEntity => ({
  ...user,
});
